import { connect } from 'react-redux'
import { Locale, Translation } from 'locale'
import React from 'react'
import { createStructuredSelector } from 'reselect'
import { GridActions } from 'store/grid'
import { GlobalGridSettings } from 'store/grid/gridTypes'
import { ToggleField } from 'view/components/toggle'
import { ToolbarToggleWrapper } from './toolbarStyles'
import { showOnlyEnabledUsersSelector } from 'selectors/globalGridSelectors'

interface EnabledUsersFilterSwitchProps {
  showOnlyEnabledUsers: boolean
  onSaveGlobalGridSettings: (globalGridSettings: Partial<GlobalGridSettings>) => unknown
}

const mapStateToProps = createStructuredSelector({
  showOnlyEnabledUsers: showOnlyEnabledUsersSelector
})

const mapDispatchToProps = {
  onSaveGlobalGridSettings: GridActions.saveGlobalGridSettings
}

const EnabledUsersFilterSwitchComponent: React.FC<EnabledUsersFilterSwitchProps> = props => {
  const { showOnlyEnabledUsers, onSaveGlobalGridSettings } = props

  const handleSwitch = (checked: boolean) => {
    onSaveGlobalGridSettings({
      showOnlyEnabledUsers: checked
    })
  }

  return (
    <ToolbarToggleWrapper>
      <ToggleField
        checked={showOnlyEnabledUsers}
        onUpdate={handleSwitch}
        label={Locale.translate(Translation.SC_SHOW_ONLY_ENABLED_USERS)}
      />
    </ToolbarToggleWrapper>
  )
}

export const EnabledUsersFilterSwitch = connect(mapStateToProps, mapDispatchToProps)(EnabledUsersFilterSwitchComponent)
